<template>
	<div class="wrap">
		<!-- browser-suggestion -->
		<browser-suggestion></browser-suggestion>
		<!-- browser-suggestion -->

		<div class="wrapper">
			<div class="list">
				<div class="title">
					<a>我的消息</a>
				</div>

				<div class="cont" v-for="(item, index) in messageList" :key="index">
					<div class="left">
						<div class="titles">
							{{ item.informtype }}
						</div>
						<div class="content" v-html="item.content"></div>
					</div>
					<div class="right">
						<div class="date">
							{{ item.createtime }}
						</div>
						<div class="middle">
							<span
								slot="label"
								v-show="
									(item.informtype == '通知' ||
										item.informtype == '体检通知' ||
										item.informtype == '入职通知') &&
										item.sysisread == '0' &&
										new Date(item.expiretime).getTime() > new Date().getTime()
								"
								>是否参加</span
							>
						</div>
						<div class="btnarea">
							<el-button
								type="primary"
								style="background: #01539f"
								@click="onConfirmRead(item.oid, '1', item.informtype)"
								v-show="
									(item.informtype == '通知' ||
										item.informtype == '体检通知' ||
										item.informtype == '入职通知') &&
										item.sysisread == '0' &&
										new Date(item.expiretime).getTime() > new Date().getTime()
								"
							>
								参加
							</el-button>
							<el-button
								type="warning"
								@click="onConfirmRead(item.oid, '-1', item.informtype)"
								v-show="
									(item.informtype == '通知' ||
										item.informtype == '体检通知' ||
										item.informtype == '入职通知') &&
										item.sysisread == '0' &&
										new Date(item.expiretime).getTime() > new Date().getTime()
								"
								>不参加</el-button
							>
						</div>
					</div>
				</div>

				<pages :total="total" :limit="limit" :offset="offset" v-if="total > 0"></pages>
			</div>

			<!-- <div class="border"></div> -->

			<!-- 弹窗 -->
			<el-dialog
				title="准考证"
				:visible.sync="dialogNoticeTicketShow"
				width="850px"
				ref="notice-ticket-dia"
				center
				close-on-click-modal
				:modal-append-to-body="false"
			>
				<div class="btn-group">
					<el-button type="primary" @click="downloadFile()"> <i class="el-icon-download"></i> 下载</el-button>
				</div>
				<div class="notice-ticket" ref="notice-ticket">
					<!-- 照片 -->
					<img src="../../assets/image/avator_man.png" alt="" class="avatar-img" />
					<!-- /照片 -->

					<div class="title">准考证</div>
					<div class="row-item margin-avatar-img">
						<div class="row-col">
							<div class="head">姓 <span class="head-some2"></span> 名：</div>
							<div class="value">{{ ticketContent.name }}</div>
						</div>
						<div class="row-col">
							<div class="head">准考证号：</div>
							<div class="value">
								{{ ticketContent.admissionTicket }}
							</div>
						</div>
					</div>
					<div class="row-item margin-avatar-img">
						<div class="row-col">
							<div class="head">身份证号：</div>
							<div class="value">{{ ticketContent.psnid }}</div>
						</div>
						<div class="row-col">
							<div class="head">考试时间：</div>
							<div class="value">{{ ticketContent.time }}</div>
						</div>
					</div>
					<div class="row-item">
						<div class="row-single">
							<div class="head">考试地点：</div>
							<div class="value">{{ ticketContent.addr }}</div>
						</div>
					</div>
					<div class="row-item">
						<div class="row-tip">
							<div class="head">注意事项：</div>
							<p class="tip">
								1.考生在考前10分钟携带准考证、身份证等有效证件进入考场，迟到30分钟不准入场 。
							</p>
							<p class="tip">
								2.考试期间考生不得携带任何书籍资料、手机等通信工具、或有储存、编程、查询功能的电子用品进入考场，否则按照违纪处理。
							</p>
						</div>
					</div>
				</div>
			</el-dialog>

			<!-- 弹窗 -->
		</div>
	</div>
</template>

<script>
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

// import searchs from '../common/search'
// import banners from '../common/banner'
import { messageData, onReadMessage } from "../request/api";
import pages from "../common/pages";
import { Message, MessageBox } from "element-ui";
import { queryUser } from "../request/regAndEdit";
import { getLoginUser } from "../../utils/auth";

export default {
	components: {
		pages,
	},
	name: "home",
	data() {
		return {
			ticketContent: {
				name: "小明",
				admissionTicket: "20210714103001",
				psnid: "110101192007147635",
				time: "2021-07-14 10:30:00",
				addr: "北京市 东城区",
			},
			dialogNoticeTicketShow: false,
			messageList: [],

			Data: {
				nameLike: "",
				type: "1",
				pageNo: "1",
				pageSize: "10",
				isIndex: "false",
				gw: "",
				xl: "",
				gzdd: "",
			},

			// 分页参数
			limit: 10,
			total: 0,
			offset: 1,
		};
	},
	mounted() {
		// console.log(this.$route)
		this.msgList();
	},
	methods: {
		waterImg(waterText) {
			// let waterText = "你好你好-你好你好你好你好";

			let waterImg = document.createElement("canvas");
			let waterImgCtx = waterImg.getContext("2d");

			waterImgCtx.save();

			// waterImgCtx 绘制
			// 绘制水印
			waterImgCtx.rotate((Math.PI / 180) * -30);
			waterImgCtx.font = "bold 24px serif";
			waterImgCtx.fillStyle = "rgba(0,0,0,0.3)";
			waterImgCtx.textAlign = "center";
			waterImgCtx.textBaseline = "Middle";

			let waterTextWidth = window.parseInt(waterImgCtx.measureText(waterText).width);
			let waterTextHeight = window.parseInt(Math.sin((Math.PI / 180) * 30) * waterTextWidth);

			waterImg.height = waterTextHeight + 60;
			waterImg.width = waterTextWidth + 60;

			waterImgCtx.restore();

			// 设置背景
			waterImgCtx.save();
			waterImgCtx.fillStyle = "#fff";
			waterImgCtx.fillRect(0, 0, waterImg.width, waterImg.height);
			waterImgCtx.restore();

			waterImgCtx.save();
			waterImgCtx.rotate((Math.PI / 180) * -30);
			waterImgCtx.font = "bold 24px serif";
			waterImgCtx.fillStyle = "rgba(0,0,0,0.3)";
			waterImgCtx.textAlign = "center";
			waterImgCtx.textBaseline = "Middle";
			// 绘制文字
			waterImgCtx.fillText(waterText, 80, waterTextHeight + 20);
			waterImgCtx.restore();

			let waterImgURL = waterImg.toDataURL("image/png");
			// console.log(waterImgURL);
			// this.testImg = waterImgURL;

			document.getElementsByClassName("notice-ticket")[0].style.background = "url(" + waterImgURL + ")";
		},
		downloadFile() {
			html2canvas(document.getElementsByClassName("notice-ticket")[0]).then(function(canvas) {
				// document.body.appendChild(canvas);
				let img = canvas.toDataURL("image/png");

				let pdf = new jsPDF("p", "pt", [595.28, 841.89]);
				pdf.addImage(img, "PNG", 20, 40, 595.28 - 40, ((595.28 - 40) / canvas.width) * canvas.height);
				pdf.save("准考证-a4.pdf");
			});
		},
		noticeTicket() {
			// this.$router.push({
			//   name: 'notice-ticket'
			// });

			// 显示
			this.dialogNoticeTicketShow = true;

			let user = getLoginUser();
			if (user) {
				var params = {
					username: user["userName"],
				};
				queryUser(params).then((res) => {
					if (res.success) {
						// res.data
						this.ticketContent.name = res.data.name || "";
						// this.ticketContent.admissionTicket = ;
						this.ticketContent.psnid = res.data.id || "";
						// this.ticketContent.time = ;
						// this.ticketContent.addr = ;

						// this.personForm.name = res.data.name || '';
						// this.personForm.id = res.data.id || '';
						// this.personForm.certificate = res.data.credtype || '';
						// this.personForm.email = res.data.email || '';
						// this.personForm.tel = res.data.telphone || '';

						let watertext = `${res.data.name}-${res.data.id}`;
						this.waterImg(watertext);
					}
				});
			}
		},
		msgList() {
			let parasm = {};
			messageData(parasm).then((res) => {
				if (res.success) {
					this.messageList = res.data;
				} else {
					Message({
						type: "error",
						message: res.message,
					});
				}
			});
		},
		onConfirmRead(oid, isjoin, informtype) {
			let data = {
				oid: oid,
				isjoin: isjoin,
				informtype: informtype,
			};
			if (isjoin == "-1") {
				let msg = "您确定不参加" + informtype.slice(0, 2) + "吗?";
				MessageBox.confirm(msg, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.readMessage(data);
				});
			} else {
				this.readMessage(data);
			}
		},
		readMessage(data) {
			onReadMessage(data).then((res) => {
				if (res.code == "1") {
					Message({
						type: "success",
						message: "已反馈给HR",
					});
					this.msgList();
				}
			});
		},
		link() {
			this.$router.push("/ofPublicList");
		},
	},
};
</script>

<style lang="scss" scoped>
.wrap {
	width: 100%;
	height: auto;
	.wrapper {
		width: 1200px;
		margin: 0 auto;
		.list {
			margin-top: 10px;
			width: 1200px;
			min-height: 800px;
			.title {
				width: 1200px;
				height: 122px;
				line-height: 122px;
				border-bottom: 1px solid #eaeaea;
				font-size: 30px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #333333;
			}
			.cont {
				width: 1200px;
				min-height: 155px;
				height: auto;
				border-bottom: 1px solid #eaeaea;
				display: flex;
				.left {
					width: 1035px;
					margin-bottom: 5px;
					.titles {
						line-height: 73px;
						font-size: 18px;
						font-family: Microsoft YaHei;
						font-weight: bold;
						color: #000000;
					}
					.content {
						width: 1035px;
						min-height: 82px;
						height: auto;
						font-size: 14px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #999999;
						line-height: 30px;
					}
				}
				.right {
					width: 165px;
					padding-left: 20px;
					box-sizing: border-box;
					.date {
						line-height: 53px;
						font-size: 14px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #999999;
						text-align: center;
					}
					.middle {
						line-height: 33px;
						font-size: 14px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #01539f;
						text-align: center;
					}
					.btnarea {
						display: flex;
						.btn {
							width: 85px;
							height: 33px;
							border-radius: 5px;
							font-size: 14px;
							font-family: Microsoft YaHei;
							font-weight: 400;
							line-height: 33px;
							text-align: center;
							cursor: pointer;
						}
						.yes {
							color: #ffffff;
							background-color: #01539f;
						}
						.no {
							margin-left: 10px;
							color: #01539f;
							background-color: #ffffff;
							border: 1px solid #01539f;
						}
					}
				}
			}
		}
	}

	// 弹窗

	.btn-group {
		margin: 0 auto;
		width: 800px;
		margin-bottom: 12px;
		text-align: right;

		.el-button {
			border-radius: 0;
			border: none;
			color: rgba(255, 255, 255, 0.8);
			height: 32px;
			width: 80px;
			padding: 0;
			font-size: 14px;
			background: #409eff;

			&:hover {
				background: #0089d0;
			}

			&:active {
				opacity: 0.5;
			}
		}
	}

	.notice-ticket {
		width: 800px;
		background: #fff;
		margin: 0 auto;
		padding: 24px;
		color: #000;
		background-repeat: repeat;
		border: 2px solid #000;
		position: relative;

		.avatar-img {
			position: absolute;
			top: 0px;
			right: 0px;
			width: 140px;
			height: 180px;
			display: block;
			// border: 1px solid #000;
			border-left: 2px solid #000;
			border-bottom: 2px solid #000;
			z-index: 10;
			opacity: 0.8;
		}

		.bg-ticket {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			z-index: 11;
		}

		.margin-avatar-img {
			margin-right: 120px;
		}

		.title {
			font-size: 48px;
			text-align: center;
			font-weight: bold;
			margin-bottom: 24px;
		}

		.row-item {
			display: flex;
			justify-content: space-between;
			margin-bottom: 12px;
		}

		.head-some2 {
			margin-right: 28px;
		}

		.row-col {
			flex: 0 0 auto;
			width: 50%;
			font-size: 18px;

			display: flex;

			.head {
				flex: 0 0 auto;
				width: 100px;
				text-align: right;
			}

			.value {
				flex: auto;
			}
		}

		.row-single {
			font-size: 18px;
			display: flex;
			.head {
				width: 100px;
				text-align: right;
			}
		}

		.tip {
			font-size: 14px;
			margin-bottom: 12px;
			margin-left: 50px;
		}

		.row-tip {
			font-size: 18px;
			.head {
				width: 100px;
				text-align: right;
				margin-bottom: 6px;
			}
		}
	}
	// 弹窗
}

@media screen and (min-width: 320px) {
}

@media screen and (min-width: 480px) {
}
/* 移动 */
@media screen and (min-width: 576px) {
}
/* 平板 */
@media screen and (min-width: 768px) {
}

/* PC */
@media screen and (min-width: 992px) {
}
@media screen and (min-width: 1200px) {
	.wrap {
		.wrapper {
			padding-left: 0;
			padding-right: 0;
			width: 1200px;
		}
	}
}
</style>
